import Api from '@/api/checkout-api'
import AuthApi from '@/api/auth-api'
import ValidationErrorHandler from '@/common/validation-error-handler'
const getOrder = async (context, payload) => {
    let res = await Api.get(payload.id, payload.key);
    if (res) {
        context.commit('ORDER_RECEIVED', res);
    } else {
        context.commit('ORDER_NOT_FOUND');
    }

}

const registerFromOrder = async (context, payload) => {
    try {
        let data = await AuthApi.registerCustomerUser(payload);
        if (data.success) {
            context.commit('ORDER_CLAIMED');
        }
        return data;
    } catch (e) {
        let validationError = ValidationErrorHandler.handle(e);
        if (validationError.handled) {
            return { success: false, errors: validationError.errors };
        }
        let success = { success: false, errors: [] }
        return success;
    }

}

const claimOrderForUser = async (context, payload) => {
    let res = await Api.claimOrder(payload.id, payload.token);
    if (res.success) {
        context.commit('ORDER_CLAIMED');
    }
}


export default {
    getOrder,
    registerFromOrder,
    claimOrderForUser
};